import React, { useState } from 'react'
import Seeker from './Seeker'
import { APISERVICE } from '../../../services/api.service'
import { formatDate } from 'utils'
import TableReport from '../../shared/report/TableReport'
import { ModalReportDetail } from '../../shared/report/ModalReportDetail'
import { userKey } from 'data/constants'
import { toast } from 'react-toastify'
const Report = () => {
	const [reports, setReports] = useState([])
	const [showReportDetail, setShowReportDetail] = useState(false)
	const [report, setReport] = useState({})
	const [loading, setLoading] = useState(false)
	// Almacena los fechas de búsqueda.
	const [search, setSearch] = useState(null)

	const searchTeacherReports = async (body) => {
		try {
			setLoading(true)
			const url = 'reporte/asistencia'
			const { success, report } = await APISERVICE.post(url, '', body)
			if (success) {
				setReports(report)
				setSearch(body)
			} else {
				setReports([])
			}
		} catch (error) {
		} finally {
			setLoading(false)
		}
	}
    const generateActividadesPdf = async (materiaId) => {
        try {
            setLoading(true)
            const token = JSON.parse(localStorage.getItem(userKey)).access_token
            const url = 'reporte/asistencia-pdf'
            const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
                headers: {
                    'content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                method: 'POST',
                body: JSON.stringify({ ...search, materiaId, detallado: true, actividades: true }),
            })

            if (response.ok) {
                const blob = await response.blob()
                // Crear una URL local para el Blob
                const blobUrl = URL.createObjectURL(blob)
    
                // Abrir una nueva pestaña con el PDF
                window.open(blobUrl, '_blank')
            } else {
                toast.error('Ocurrió un error al obtener el reporte')
            }

        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

	return (
		<div className='contenedor reports'>
			<div className='title-enable-teacher fs-3'>Reportes</div>
			<Seeker searchTeacherReports={searchTeacherReports} reports />
			{search && (
				<div>
					<span className='fw-bold'>Fecha:</span> desde
					<span className='mx-1'>{formatDate(search.startDate, 'd/m/Y')}</span>- hasta
					<span className='mx-1'>{formatDate(search.endDate, 'd/m/Y')}</span>
				</div>
			)}
			{reports.map((teacher, index) => (
				<div key={index}>
					<div className='px-2 py-3' style={{ borderBottom: '1px solid #dee2e6' }}>
						<span className='fw-bold'>Docente:</span> {teacher.nombre}
					</div>
					<TableReport
						subjects={teacher.subjects}
						setShowReportDetail={setShowReportDetail}
						setReport={setReport}
						loading={loading}
                        generateActividadesPdf={generateActividadesPdf}
					/>
				</div>
			))}
			<ModalReportDetail show={showReportDetail} report={report} onHide={setShowReportDetail} />
		</div>
	)
}

export default Report
